import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import authClient from 'services/AuthService';
import { getDefaultHomeRoute } from 'util/Route';
import { ConfigContext } from 'components/ConfigGuard';
import { UserContext } from 'components/UserGuard';

const RedirectPage: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { enabledModules } = useContext(ConfigContext);
  const { setCurrentUser } = useContext(UserContext);
  const defaultHomeRoute: string = useMemo(() => getDefaultHomeRoute(enabledModules), [enabledModules]);

  useEffect(() => {
    const params: URLSearchParams = new URLSearchParams(search);
    const idToken: string = params.get('id_token') || '';
    const sessionState: string = params.get('session_state') || '';
    const returnUrl: string = params.get('returnUrl') || defaultHomeRoute;

    if (idToken) {
      if (authClient.isAuthenticated()) {
        authClient.setAuthCookies();
      }
      authClient.setAuthCookies({ idToken, sessionState });
    }
    navigate(returnUrl, { replace: true });
  }, [search, navigate, defaultHomeRoute, setCurrentUser, enqueueSnackbar]);

  return <></>;
};
export default RedirectPage;
